<template>
  <div>
    <button class="btn btn-dark" v-on:click="save">Save</button>
    <b-tabs pills vertical>
      <b-tab title="General" active>
        <b-form-checkbox
          switch
          size="lg"
          v-model="$piggyBank.data.settings.general.autoSave"
        >Auto save</b-form-checkbox>
        <Colorex :color="$piggyBank.data.settings.general.color" @changed="setColor"></Colorex>
      </b-tab>
      <b-tab title="Salaries template">
        <button class="btn btn-dark" v-on:click="addSalary"><font-awesome-icon icon="plus"/></button>
        <Salaries ref="salaries" v-bind:salaries="$piggyBank.data.settings.salaries" @refresh="refreshSalaries"></Salaries>
      </b-tab>
      <b-tab title="Expenses template">
        <button class="btn btn-dark" v-on:click="addExpense"><font-awesome-icon icon="plus"/></button>
        <Expenses ref="expenses" v-bind:expenses="$piggyBank.data.settings.expenses" @refresh="refreshExpenses"></Expenses>
      </b-tab>

      <b-tab title="Import / Export">
        <input type="file" @change="importData" accept="application/json" />
        <button v-on:click="exportData">Export</button>
      </b-tab>
    </b-tabs>

    <ModalQuestion ref="question"></ModalQuestion>
    <ExpenseEdit ref="expense"></ExpenseEdit>
    <SalaryEdit ref="salary"></SalaryEdit>
  </div>
</template>

<script>
export default {
  methods: {
    setColor(color) {
      this.$piggyBank.data.settings.general.color = color;
    },
    refreshExpenses(expenses) {
      this.$piggyBank.data.settings.expenses = [...expenses];
      this.$forceUpdate();
    },
    refreshSalaries(salaries) {
      this.$piggyBank.data.settings.salaries = [...salaries];
      this.$forceUpdate();
    },    
    save() {
      this.$piggyBank.data.saveSetting();
    },
    addSalary() {
      let salary = this.$piggyBank.data.newSalary({
        months: [...Array(12).keys()].map(key =>key + 1)
      });

      this.$refs.salaries.addSalary(salary);
    },
    addExpense() {
      let expense = this.$piggyBank.data.newExpense({
        months: [...Array(12).keys()].map(key =>key + 1)
      });

      this.$refs.expenses.addExpense(expense);
    },
    importData(event) {
      let file = event.target.files[0];
      if (!file) {
        return;
      }

      let reader = new FileReader();
      reader.onload = e => {
        let data = JSON.parse(e.target.result);
        this.$piggyBank.data.import(data);
      };
      reader.readAsText(file);
    },
    exportData() {}
  }
};
</script>